module.exports = "/assets/data/429c9396afb38cac3e44a48aa3baf401-CH48.data.json";